import { useSelector, useDispatch } from 'react-redux'
import {fetchGeoJson } from '../state/uiActions'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisH, faToggleOn, faToggleOff,  faEyeSlash, faMapMarkerAlt, faRoute} from '@fortawesome/free-solid-svg-icons'

import {SET_EXTRA_MAP_FEATURES_VISIBILITY} from '../state/viewportActions.js'

import Dropdown from 'react-bootstrap/Dropdown'

export default function ViewportLayersMenu(props) {
  const dispatch = useDispatch(); 

  const features = useSelector((state) => state.viewport.extraMapFeatures)
  const featuresVisibility = useSelector((state) => state.viewport.extraMapFeaturesVisibility)
  const geoJsons = useSelector((state) => state.viewport.geoJsons) ;  
  
  const handleClick = (key, visibility) => {
    // lazy load geojsons: fetch when first needed only
    if (visibility && ! geoJsons[key]) {
      // TODO: features should be indexed by the key
      var gurl ; 
      for (const item of features.items){
        if (item['key']==key) gurl = item['lineGeoJsonUrl']    
      }
      if ((typeof gurl !== 'undefined')) {
        console.log('GeoJSON to be fetched:', gurl)
        dispatch( fetchGeoJson(key, gurl) )
      }
    }
    dispatch({ type: SET_EXTRA_MAP_FEATURES_VISIBILITY, key: key, visibility: visibility })
  }

  var toggle ;
    
  if (! (features && Object.keys(features).length > 0 ) ) return null ;

  const setAllItemsVisibility = (visible) => {  
    features.items.map( (item, index) => {
      handleClick(item.key, visible)
    })
  }

  return (
    <div>
      <Dropdown>
        <div className="d-grid gap-2"> 
          <Dropdown.Toggle variant="outline-secondary" className="menu-item-row allSelector btn-sm text-left">
            ÖSSZES 
            <span style={{ float: 'right' }}>
              <FontAwesomeIcon icon={faEllipsisH} /> 
            </span>
          </Dropdown.Toggle>
        </div>
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => setAllItemsVisibility(false)}>kikapcsol</Dropdown.Item>
          <Dropdown.Item onClick={() => setAllItemsVisibility(true)}>bekapcsol</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      {/* 
      <div className="dropdown-menu allSelectorMenu">
        <a className="dropdown-item btn btn-sm" style={{display: 'flex'}} href="#"
          onClick={() => this.setAllItemVisibility('hidden')}>
          <div style={{width: '30px'}}><FontAwesomeIcon icon={faEyeSlash} color="grey"/></div>
          <div style={{flexGrow: '1'}}> &nbsp; kikapcsol</div>
        </a>
        <a className="dropdown-item btn btn-sm" style={{display: 'flex'}} href="#"
          onClick={() => this.setAllItemVisibility('lastStates')}>
          <div style={{width: '30px'}}><FontAwesomeIcon icon={faMapMarkerAlt} color="green"/></div>
          <div style={{flexGrow: '1'}}> &nbsp; hol vannak</div>
        </a>
        <a className="dropdown-item btn btn-sm" style={{display: 'flex'}} href="#"
          onClick={() => this.setAllItemVisibility('trajectories')}>
          <div style={{width: '30px'}}>
            <FontAwesomeIcon icon={faMapMarkerAlt} color="green"/> <FontAwesomeIcon icon={faRoute} color="green"/></div>
          <div style={{flexGrow: '1'}}>&nbsp; merre mentek</div>
        </a>
        <a>
            <MapFitBoundsRow
              name={'zoom'}
              getMap={this.props.getMap}
              itemMoLastStates={this.props.itemMoLastStates}
              itemLastStateVisible={this.props.itemLastStateVisible}
            /> 
          </a>
      </div>
      */}
    
    { 
      features.items.map( (item, index) => {
        var key = 'nokey'
        try {
          key = item.key 
        } catch {
          console.log('WARN: invalid / no viewport layer item key.')
        }   
        if  (featuresVisibility[item.key] ) 
          toggle = ( <FontAwesomeIcon icon={faToggleOn} color="green"/> ) ;
        else 
          toggle= ( <FontAwesomeIcon icon={faToggleOff} />  ) ;
        return (
          <div key={key}>
            <button type="button" className="menu-item-row btn btn-outline-secondary btn-block btn-sm text-left"
                    onClick={() => handleClick(item.key, ! featuresVisibility[item.key])}>
              {toggle} &nbsp; {item.name}
            </button>
          </div>
        );
      } )    
    }
    </div>
  )
   


}